import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import { tokens } from "./tokens";

// Confirm / Cancel button row at the bottom of every sheet.
// Primary uses the prototype's brand green; destructive uses red.

const SheetButtons = ({
  onCancel,
  onConfirm,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  loading = false,
  disabled = false,
  destructive = false,
}) => (
  <View style={styles.row}>
    <TouchableOpacity
      activeOpacity={0.85}
      style={[styles.btn, styles.cancel]}
      onPress={onCancel}
      disabled={loading}
    >
      <Text variant="caption_2" style={styles.cancelText}>
        {cancelLabel}
      </Text>
    </TouchableOpacity>
    <TouchableOpacity
      activeOpacity={0.85}
      style={[
        styles.btn,
        destructive ? styles.danger : styles.primary,
        (loading || disabled) && styles.disabled,
      ]}
      onPress={onConfirm}
      disabled={loading || disabled}
    >
      <Text variant="caption_2" style={styles.primaryText}>
        {loading ? "Working…" : confirmLabel}
      </Text>
    </TouchableOpacity>
  </View>
);

export default SheetButtons;

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    justifyContent: "flex-end",
    paddingTop: tokens.spacing.medium,
  },
  btn: {
    paddingHorizontal: tokens.spacing.large,
    paddingVertical: 10,
    borderRadius: tokens.radius.md,
    borderWidth: 1,
    marginLeft: tokens.spacing.small,
  },
  cancel: {
    borderColor: tokens.borderMedium,
    backgroundColor: tokens.surface,
  },
  cancelText: { color: tokens.textHeading, fontSize: 13, fontWeight: "600" },
  primary: {
    backgroundColor: tokens.accent.bg,
    borderColor: tokens.accent.bg,
  },
  danger: {
    backgroundColor: tokens.error,
    borderColor: tokens.error,
  },
  primaryText: { color: tokens.accent.fg, fontSize: 13, fontWeight: "700" },
  disabled: { opacity: 0.5 },
});
